"use strict";

(function () {
  const ID_MODAL_BACKDROP = 'modal__backdrop';
  const ID_MODAL_DIALOG = 'modal__dialog';
  const ID_MODAL_CLOSE = 'modal__close';
  const ID_MODAL_LOADING_PANE = 'modal__loadingPane';
  const CLASS_MODAL_DIALOG = 'modal__dialog';
  const CLASS_OPEN = '--open';
  const CLASS_LOADER = '--loader';
  const ATTR_HIDDEN = 'hidden';
  const DATA_MODAL_SEND_ONCLOSE = 'data-modal-send-onclose';
  const DATA_MODAL_CLOSEABLE = 'data-modal-closeable';
  const DATA_MODAL_CLOSEABLE_BY_BACKDROP_CLICK = 'data-modal-closeable-by-backdrop-click';
  let openDialogElement = null;
  let isClosable = true;
  let isClosableByBackdropClick = true;
  let pendingScrollRestore = null;
  const KVIK_MODAL_SIZES = {
    default: 'default',
    full: 'full'
  };
  function createCloseElement(dialogElement) {
    const closeElement = document.createElement('button');
    closeElement.id = ID_MODAL_CLOSE;
    closeElement.addEventListener('click', () => {
      document.dispatchEvent(new CustomEvent('kvik_event_modal_closed_by_user'));
      destroy();
    });
    dialogElement.appendChild(closeElement);
    return closeElement;
  }
  function createBackdropElement(dialogElement, isClosableByBackdropClick) {
    const backdropElement = document.createElement('div');
    backdropElement.id = ID_MODAL_BACKDROP;
    if (isClosableByBackdropClick) {
      // Prevent backdrop click when dragging range input (i.e. yearSlider)
      let isDragging = false;
      document.addEventListener('mousedown', e => {
        if (e.target.matches('input[type="range"]')) {
          isDragging = true;
          const onMouseUp = () => {
            isDragging = false;
            document.removeEventListener('mouseup', onMouseUp);
          };
          document.addEventListener('mouseup', onMouseUp, {
            once: true
          });
        }
      });
      backdropElement.addEventListener('mousedown', e => {
        if (e.target === backdropElement) {
          document.dispatchEvent(new CustomEvent('kvik_event_modal_closed_by_user'));
          destroy();
        }
      });
      dialogElement.addEventListener('click', e => {
        if (e.target.matches('input[type="range"]')) {
          e.stopPropagation();
        }
      }, true);
    }
    dialogElement.parentNode.insertBefore(backdropElement, dialogElement);
    return backdropElement;
  }
  function createLoadingPaneElement(dialogElement) {
    const loadingPaneElement = document.createElement('div');
    loadingPaneElement.id = ID_MODAL_LOADING_PANE;
    loadingPaneElement.setAttribute(ATTR_HIDDEN, true);
    loadingPaneElement.innerHTML = km_spinner.html;
    loadingPaneElement.style.height = `max(100%, ${dialogElement.scrollHeight}px)`;
    dialogElement.appendChild(loadingPaneElement);
    return loadingPaneElement;
  }
  function initDismissElements(dialogElement) {
    const dismissElements = dialogElement.querySelectorAll('*[data-dismiss=modal]');
    for (let i = 0; i < dismissElements.length; i++) {
      dismissElements[i].addEventListener('click', event => {
        event.preventDefault();
        destroy();
      });
    }
  }
  function closeIfClosable() {
    if (isClosable) {
      destroy();
    }
    return !openDialogElement;
  }
  function destroy() {
    let destroyImmediately = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (!destroyImmediately) {
      const element = openDialogElement?.querySelector(`[${DATA_MODAL_SEND_ONCLOSE}]`);
      if (element) {
        window.kvik_ajax.sendRequestFromElement(element);
      }
    }
    for (let id of [ID_MODAL_BACKDROP, ID_MODAL_DIALOG]) {
      const element = document.getElementById(id);
      if (!element) {
        continue;
      }
      if (element.id === ID_MODAL_DIALOG) {
        const eventDetail = {
          dialogElement: element
        };
        setTimeout(function () {
          document.dispatchEvent(new CustomEvent('kvik_event_modal_destroy', {
            detail: eventDetail
          }));
        }, 200);
      }
      if (destroyImmediately) {
        element.parentElement.removeChild(element);
      } else {
        element.classList.remove(CLASS_OPEN);
        setTimeout(function () {
          element.parentElement.removeChild(element);
        }, 250);
      }
    }
    openDialogElement = null;
  }
  function getElementInnerHeight(element) {
    const computedStyles = getComputedStyle(element);
    return element.clientHeight - parseInt(computedStyles.paddingTop) - parseInt(computedStyles.paddingBottom);
  }
  function setPendingScrollRestore() {
    if (openDialogElement) {
      pendingScrollRestore = openDialogElement.scrollTop;
    }
  }
  function showDialog(dialogElement) {
    let config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const wasOpen = openDialogElement && !openDialogElement.classList.contains(CLASS_LOADER);
    destroy(true);
    isClosable = config.isCloseable ?? (dialogElement.hasAttribute(DATA_MODAL_CLOSEABLE) ? Boolean(parseInt(dialogElement.getAttribute(DATA_MODAL_CLOSEABLE))) : true);
    isClosableByBackdropClick = config.isCloseable ?? (dialogElement.hasAttribute(DATA_MODAL_CLOSEABLE_BY_BACKDROP_CLICK) ? Boolean(parseInt(dialogElement.getAttribute(DATA_MODAL_CLOSEABLE_BY_BACKDROP_CLICK))) : true);
    document.body.appendChild(dialogElement);
    dialogElement.id = ID_MODAL_DIALOG;
    if (config.classModifier) {
      dialogElement.classList.add(config.classModifier);
    }
    if (config.size) {
      dialogElement.classList.add('--size-' + config.size);
    }
    if (config.isPositionRelative) {
      dialogElement.classList.add('--position-relative');
    }
    if (wasOpen) {
      dialogElement.classList.add(CLASS_OPEN);
    }
    dialogElement.showModal();

    // Because AdBlock sets `display: none` on `class=cookieConsent`. Therefore the <dialog> have hidden children so zero height.
    if (getElementInnerHeight(dialogElement) <= 0) {
      console.warn('Destroying modal <dialog> because its inner size is zero.', dialogElement);
      destroy(true);
      return;
    }
    setTimeout(function () {
      dialogElement.classList.add(CLASS_OPEN);
    }, 50);
    createBackdropElement(dialogElement, isClosableByBackdropClick);
    createLoadingPaneElement(dialogElement);
    if (isClosable && !config.isCloseElementHidden) {
      createCloseElement(dialogElement);
    }
    if (isClosableByBackdropClick) {
      dialogElement.addEventListener('click', function (event) {
        const rect = dialogElement.getBoundingClientRect();
        const isInDialog = rect.height === 0 && rect.width === 0 || rect.top <= event.clientY && event.clientY <= rect.top + rect.height && rect.left <= event.clientX && event.clientX <= rect.left + rect.width;
        if (!isInDialog && event.isTrusted) {
          document.dispatchEvent(new CustomEvent('kvik_event_modal_closed_by_user'));
          destroy();
        }
      });
    }
    initDismissElements(dialogElement);
    openDialogElement = dialogElement;
    const eventDetail = {
      dialogElement
    };
    document.dispatchEvent(new CustomEvent('kvik_event_modal_show_modal_before', {
      detail: eventDetail
    }));
    setTimeout(function () {
      if (config && config.callback) {
        config.callback(eventDetail);
      }
      document.dispatchEvent(new CustomEvent('kvik_event_modal_show_modal', {
        detail: eventDetail
      }));
    }, 300);
  }
  function isDialogElement(element) {
    return element instanceof HTMLElement && element.localName === 'dialog';
  }
  function showModal(content) {
    let config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      dispatchEvent: true
    };
    let dialogElement = document.createElement('dialog');
    let evaluateScripts = false;
    if (content instanceof Element) {
      dialogElement.appendChild(content);
    } else {
      dialogElement.innerHTML = content;
      evaluateScripts = true;
    }
    if (isDialogElement(dialogElement.firstChild)) {
      dialogElement = dialogElement.firstChild;
    }
    document.body.appendChild(dialogElement);
    if (evaluateScripts) {
      const scripts = dialogElement.getElementsByTagName('script');
      for (let i = 0; i < scripts.length; i++) {
        eval(scripts[i].textContent);
      }
    }
    showDialog(dialogElement, config);
  }
  function showLoader() {
    const loadingPaneElement = document.getElementById(ID_MODAL_LOADING_PANE);
    if (loadingPaneElement) {
      loadingPaneElement.removeAttribute(ATTR_HIDDEN);
    } else {
      showModal(km_spinner.htmlLight, {
        isCloseable: false,
        classModifier: CLASS_LOADER
      });
    }
  }
  function isLoaderShown() {
    if (!openDialogElement) {
      return false;
    }
    if (openDialogElement.classList.contains(CLASS_LOADER)) {
      return true;
    }
    const loadingPaneElement = document.getElementById(ID_MODAL_LOADING_PANE);
    return loadingPaneElement && !loadingPaneElement.hidden;
  }
  function loadFromDOM() {
    const dialogElement = document.getElementsByClassName(CLASS_MODAL_DIALOG)[0];
    if (dialogElement) {
      showModal(dialogElement);
    }
  }
  window.kvik_modal = {
    showLoader,
    showModal,
    destroy,
    isLoaderShown,
    setPendingScrollRestore,
    SIZES: KVIK_MODAL_SIZES
  };
  onDOMReady(function () {
    loadFromDOM();
    document.addEventListener('keyup', function (event) {
      if (event.key === 'Escape' && openDialogElement && closeIfClosable()) {
        event.stopPropagation();
        event.preventDefault();
      }
    });
    window.addEventListener('pageshow', () => {
      if (isLoaderShown()) {
        destroy(true);
      }
    });
    const restoreScroll = () => {
      if (pendingScrollRestore !== null && openDialogElement) {
        openDialogElement.scrollTop = pendingScrollRestore;
        pendingScrollRestore = null;
      }
    };
    document.addEventListener('kvik_event_ajax_snippets_update', restoreScroll);
    document.addEventListener('kvik_event_modal_show_modal_before', restoreScroll);
  });
})();

// jQuery free